import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: 'Company',
      links: [
        { name: 'About Us', url: '#about' },
        { name: 'Careers', url: '#' },
        { name: 'News', url: '#' },
        { name: 'Contact', url: '#contact' }
      ]
    },
    {
      title: 'Solutions',
      links: [
        { name: 'Customer Service', url: '#solutions' },
        { name: 'Data Processing', url: '#solutions' },
        { name: 'Workflow Automation', url: '#solutions' },
        { name: 'Custom AI Solutions', url: '#contact' }
      ]
    },
    /*{
      title: 'Resources',
      links: [
        { name: 'Blog', url: '#' },
        { name: 'Documentation', url: '#' },
        /!*{ name: 'Case Studies', url: '#success-stories' },*!/
        { name: 'FAQ', url: '#' }
      ]
    },*/
    /*{
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', url: '#' },
        { name: 'Terms of Service', url: '#' },
        { name: 'Cookie Policy', url: '#' },
        { name: 'GDPR Compliance', url: '#' }
      ]
    }*/
  ];

  return (
    <footer className="bg-dark-blue relative">
      {/* Top border with gradient */}
      <div className="h-1 w-full bg-gradient-to-r from-electric-blue to-teal-accent"></div>
      
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Logo and description */}
          <div className="lg:col-span-2">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="mb-6"
            >
              <span className="text-2xl font-display font-bold gradient-text">Atomcx.ai</span>
            </motion.div>
            <p className="text-gray-400 mb-6 max-w-md">
              Empowering businesses with intelligent AI agents that automate workflows, 
              enhance productivity, and drive innovation in today's digital landscape.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://linkedin.com/company/atomcx-ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-deep-blue rounded-full flex items-center justify-center border border-electric-blue/30 hover:bg-electric-blue/20 transition-colors"
              >
                <span className="text-electric-blue">Li</span>
              </a>
              <a 
                href="https://twitter.com/atomcx_ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-deep-blue rounded-full flex items-center justify-center border border-electric-blue/30 hover:bg-electric-blue/20 transition-colors"
              >
                <span className="text-electric-blue">Tw</span>
              </a>
              {/*<a
                href="https://github.com/atomcx-ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-deep-blue rounded-full flex items-center justify-center border border-electric-blue/30 hover:bg-electric-blue/20 transition-colors"
              >
                <span className="text-electric-blue">Gh</span>
              </a>*/}
            </div>
          </div>
          
          {/* Footer links */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="text-white font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.url} 
                      className="text-gray-400 hover:text-electric-blue transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        {/* Bottom section with copyright */}
        <div className="pt-8 border-t border-electric-blue/20 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Atomcx.ai. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-500 hover:text-electric-blue text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-electric-blue text-sm transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-electric-blue text-sm transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;